/* eslint-disable react/no-unknown-property */
import PageLayout from 'components/Layouts/PageLayout/PageLayout';
import {
  useAppSelector,
} from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { ServiceCode } from 'store/user/types/service';
import { ReactComponent as DatabaseIcon } from 'assets/icons_3/database-02.svg';
import ServiceNoData from 'components/ServiceNoData/ServiceNoData';

const DatabaseLayout: React.FC = () => {
  const user = useAppSelector((state) => state.user);
  const [t] = useTranslation();

  const isServiceEnabledInRegion = React.useMemo(() => {
    const services = user.services.filter((service) => service.code === ServiceCode.dbaas);
    if (services.length === 0) {
      return false;
    }
    return services.some((service) => service.regionId === user.region?.id);
  }, [user]);

  const enabledRegions = user.services
    .filter((service) => service.code === ServiceCode.dbaas)
    .map((service) => service.regionId)
    .map((regionId) => user.regions.find((region) => region.id === regionId)?.name);

  if (isServiceEnabledInRegion) {
    return <Outlet />;
  }

  return (
    <PageLayout title={t('db.self_plural')}>
      <ServiceNoData
        icon={<DatabaseIcon />}
        title={t('db.title')}
        descriptions={[`${t('no_data.region_disabled_1')} "${t('db.self_plural')}" ${t('no_data.region_disabled_2', { availabilityZone: enabledRegions.join(', ') })}.`]}
      />
    </PageLayout>
  );
};

export default DatabaseLayout;
